import { render, staticRenderFns } from "./LoanForm.vue?vue&type=template&id=61b2366d&"
import script from "./LoanForm.vue?vue&type=script&lang=js&"
export * from "./LoanForm.vue?vue&type=script&lang=js&"
import style0 from "./LoanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports